import PropTypes from 'prop-types';
import React from 'react';
import Avatar from 'react-avatar';
import {
  ButtonToolbar,
  Button,
} from 'react-bootstrap';
import Dropzone from 'react-dropzone';

import AgentCard from './AgentCard';
import AgentTable from './AgentTable';
import AgentSendMenu from './AgentSendMenu';
import Layout from '../../../components/Layout';
import Loading from '../../../components/Loading'
// import Loading from '../../../components/Loading';

class Agency extends React.Component {

  constructor(props) {
    super(props);
    this.state = { isExpanded: true };
    this.onDrop = this.onDrop.bind(this);
    this.expand = this.expand.bind(this);
    this.collapse = this.collapse.bind(this);

  }
  onDrop(acceptedFiles) {
    console.log(acceptedFiles);
    this.setState({
      files: acceptedFiles,
    });
    this.props.editAgencyImage(this.props.agency.id, acceptedFiles);
  }
  expand(e) {
    e.preventDefault();
    this.setState({
      isExpanded: true
    });
  }
  collapse(e) {
    e.preventDefault();
    this.setState({
      isExpanded: false
    });
  }

  componentWillMount() {
    if (this.props.needFetch) {
      this.props.requestAgency();
    }
  }
  render() {
    if (this.props.isFetching) {
      return (
        <Layout>
          <Loading />
        </Layout>
      );
    }
    return (
      <Layout>
        <div className="container-fluid">
          <div className="row agency-header">
            <div className="col-sm-12">
              <Dropzone
                accept="image/*"
                ref={(node) => { this.dropzone = node; }}
                onDrop={this.onDrop}
                multiple={false}
                className="agency-logo"
                acceptClassName="drop-accept"
                rejectClassName="drop-reject"
              >
                <Avatar name={this.props.agency.name} src={this.props.agency.logo} className="agency-logo" />
              </Dropzone>
              <div className="agency-title">
                <h1>{this.props.agency.name}</h1>
                <p>IATA#: {this.props.agency.iata}</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <AgentSendMenu
                id={this.props.agency.id}
                agency={this.props.agency}
                editAgency={this.props.editAgency}
                sendAgentInvite={this.props.sendAgentInvite}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12">
              <div className="row agent-table-header">
                <h1>Agents</h1>
                <ButtonToolbar>
                  <Button bsStyle="default" onClick={this.expand}>
                    <i className="fa fa-th-large"></i>
                  </Button>
                  <Button bsStyle="default" onClick={this.collapse}>
                    <i className="fa fa-bars"></i>
                  </Button>
                </ButtonToolbar>
              </div>
              <AgentTable isExpanded={this.state.isExpanded} agents={this.props.agency.agents} />
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}
Agency.propTypes = {
  agency: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    iata: PropTypes.string,
    logo: PropTypes.string,
    image: PropTypes.string,
    agents: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  needFetch: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  requestAgency: PropTypes.func.isRequired,
  sendAgentInvite: PropTypes.func.isRequired,
  // addAgent: PropTypes.func.isRequired,
  editAgency: PropTypes.func.isRequired,
  editAgencyImage: PropTypes.func.isRequired,
};
Agency.defaultProps = {
  agency: {
    id: null,
  },
};

export default Agency;



// WEBPACK FOOTER //
// src/routes/agency/components/Agency.js